import { query } from 'src/utils/request';

// 获取下拉框配置项
export const getCommonConfig = data => {
  return query('/zlb/api/financial/intercourse/common/select-config', {
    method: 'POST',
    data,
  });
};

// 列表
export const getRegisterList = data => {
  return query('/zlb/api/financial/intercourse/manage/list', {
    method: 'POST',
    data,
  });
};

// 获取登录人信息
export const getDefaultInfo = () => {
  return query('/zlb/api/financial/intercourse/common/default-info');
};

// 登记
export const register = data => {
  return query('/zlb/api/financial/intercourse/manage/register', {
    method: 'POST',
    data,
  });
};

// 往来单详情
export const getIntercourseDetail = params => {
  return query(`/zlb/api/financial/intercourse/manage/detail/${params.intercourseId}`);
};

// 更新状态
export const updateIntercourseStatus = data => {
  return query('/zlb/api/financial/intercourse/manage/update', {
    method: 'POST',
    data,
  });
};

// 往来单删除
export const deleteIntercourse = params => {
  return query(`/zlb/api/financial/intercourse/manage/delete/${params.intercourseId}`);
};

// 获取打印文件详情
export const printIntercourse = params => {
  return query(`/zlb/api/financial/intercourse/common/print-info/${params.intercourseId}`);
};
